import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function ImportUtility(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const {
    vars: {
      palette: { primary, secondary }
    }
  } = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "ImportUtility", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M43.0005 13.6132v-3.612c0-.52997-.211-1.03898-.586-1.41398s-.884-.586-1.414-.586H18.8524c.047.082.089.16801.125.25701l.994 4.09797c.304.759 1.039 1.257 1.857 1.257h21.1721Z",
        fill: primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M45.0002 13.9994c0-.5298-.211-1.0389-.586-1.4138-.375-.3748-.884-.586-1.414-.586H24.3541c-.818 0-1.553-.4984-1.857-1.2567-.304-.76049-.69-1.72574-.994-2.48623C21.1991 7.49725 20.4641 7 19.6461 7H5.00001c-.53 0-1.03901.21017-1.41401.585C3.211 7.96091 3 8.469 3 8.99983V34.9997c0 1.104.895 1.9999 2.00001 1.9999H43.0002c.53 0 1.039-.2113 1.414-.5861.375-.3748.586-.884.586-1.4138V13.9994Z",
        fill: secondary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "m24 17-6 6.1347h3V41h6V23.1347h3L24 17Z", fill: primary.dark })
  ] });
}
ImportUtility.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "ImportUtility"
};
validateTidalLicense();
export {
  ImportUtility
};
//# sourceMappingURL=ImportUtility.js.map
